import { render, staticRenderFns } from "./TaskMenu.vue?vue&type=template&id=1776bf16&scoped=true"
import script from "./TaskMenu.vue?vue&type=script&lang=js"
export * from "./TaskMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1776bf16",
  null
  
)

export default component.exports